import random from 'lodash/random';

export function randomArrayElement<T>(arr: T[]): T | null {
  if (arr.length === 0)
    return null;

  const index = random(0, arr.length - 1, false);
  return arr[index];
}